'use client';
import { useSearchParams } from 'next/navigation';

import ChatWidget from '@/components/site/ChatWidget';

export default function ChatWidgetPage() {
  const searchParams = useSearchParams();

  const keyFromSearchParams = searchParams?.get('key');
  const demoParams = searchParams?.get('demo');

  if (!keyFromSearchParams) {
    return null;
  }

  const key = parseInt(keyFromSearchParams || '');

  return <ChatWidget teamId={key} demo={demoParams === 'true'} />;
}
